<app-absence-group-grid [isAdminView]="true" [reviewMode]="true"></app-absence-group-grid>
